import { apiClient } from '@/lib/api/client';
import type { ApiEnvelope } from '@/types/api';
import type {
  UtilityCountry,
  UtilityCommunity,
  TranslateInitiativeInput,
  TranslateInitiativeResponse,
  ExchangeRateInput,
  ExchangeRateResponse,
  StoreDeviceTokenInput,
} from '@/types/utility';

export async function getCommunities(
  cityId?: string
): Promise<ApiEnvelope<UtilityCommunity[]>> {
  const path = cityId
    ? `/api_partner/communities?city_id=${encodeURIComponent(cityId)}`
    : '/api_partner/communities';
  return apiClient.get<UtilityCommunity[]>(path);
}

export async function getCountryDetails(
  countryId: string
): Promise<ApiEnvelope<UtilityCountry>> {
  return apiClient.get<UtilityCountry>(`/api_partner/countries/${countryId}`);
}

export async function storeDeviceToken(
  input: StoreDeviceTokenInput
): Promise<ApiEnvelope<null>> {
  return apiClient.post<null>('/api_partner/store_device_token', input);
}

export async function translateInitiative(
  input: TranslateInitiativeInput
): Promise<ApiEnvelope<TranslateInitiativeResponse>> {
  return apiClient.post<TranslateInitiativeResponse>(
    '/api_partner/ai/initiative/translate',
    input
  );
}

export async function getExchangeRate(
  input: ExchangeRateInput
): Promise<ApiEnvelope<ExchangeRateResponse>> {
  return apiClient.post<ExchangeRateResponse>(
    '/api_partner/ai/exchange-rate',
    input
  );
}
